"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_native_exports = {};
__export(index_native_exports, {
  Localization: () => Localization,
  useCalendars: () => useCalendars,
  useLocales: () => useLocales
});
module.exports = __toCommonJS(index_native_exports);
var import_react = require("react");
var import_react_native_nitro_modules = require("react-native-nitro-modules");
var import_map = require("./map");
var hybrid;
function native() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = import_react_native_nitro_modules.NitroModules.createHybridObject("OneDevice");
  return hybrid;
}
function getLocales() {
  return (0, import_map.toLocales)(native().getLocales());
}
function getCalendars() {
  return (0, import_map.toCalendars)(native().getCalendars());
}
function useLocales() {
  var [locales, setLocales] = (0, import_react.useState)(function() {
    return getLocales();
  });
  (0, import_react.useEffect)(function() {
    setLocales(getLocales());
    return native().addLocalizationListener(function() {
      return setLocales(getLocales());
    });
  }, []);
  return locales;
}
function useCalendars() {
  var [calendars, setCalendars] = (0, import_react.useState)(function() {
    return getCalendars();
  });
  (0, import_react.useEffect)(function() {
    setCalendars(getCalendars());
    return native().addLocalizationListener(function() {
      return setCalendars(getCalendars());
    });
  }, []);
  return calendars;
}
var Localization = Object.freeze({
  getLocales,
  getCalendars
});
//# sourceMappingURL=index.native.js.map
